export default __webpack_public_path__ + "static/media/opensans-bold-webfont.18cb3c08.woff2";